// This is a copy of the PushPermissionStatus enum from the
// customerio-reactnative package to avoid importing the package into types
// which will break the build for the web.
export enum PushPermissionStatus {
  Granted = "GRANTED",
  Denied = "DENIED",
  NotDetermined = "NOTDETERMINED",
}

type PushNotificationResponseSuccess = {
  success: true;
  permissionStatus: PushPermissionStatus;
};

type PushNotificationResponseError = {
  success: false;
  message: string;
};

export type PushNotificationResponse =
  | PushNotificationResponseSuccess
  | PushNotificationResponseError;

export type ShowPromptProps = {
  redirect?: () => void;
};

export type PushNotificationsPromptsProps = {
  redirect?: () => void;
  permissionStatus: PushPermissionStatus;
};

export type PushNotificationsConfig = {
  customerioSiteId: string;
  customerioCdpApiKey: string;
};

export type PushNotificationsServiceInterface = {
  initialize: (config: PushNotificationsConfig) => Promise<void>;
  showPermissionStatusPrompt: (
    userId?: string,
  ) => Promise<PushNotificationResponse>;
  getPermissionStatus: () => Promise<PushNotificationResponse>;
  deregisterDevice: () => Promise<void>;
  registerDevice: (email: string, userId: string) => Promise<void>;
  updateTraits: (
    userId: string,
    traits: Record<string, unknown>,
  ) => Promise<void>;
};
